exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".circular-progress .CircularProgressbar {\n  width: 41px;\n  height: 41px; }\n\n.circular-progress .CircularProgressbar-trail {\n  stroke: #58595b; }\n\n.circular-progress .progress-error .CircularProgressbar-path {\n  stroke: #fe8d6f; }\n\n.circular-progress .progress-sucess .CircularProgressbar-path {\n  stroke: #00be0e; }\n", ""]);

